import { useCallback, useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';

import { TreeList, orderBy, filterBy, TreeListTextFilter } from "@progress/kendo-react-treelist";

const subItemsField = "children";
const expandField = "expanded";
export const AssociateActions = ({ values, data, t, handleDirectInputChange }) => {
    const [state, setState] = useState({
        data: [],
        dataState: {
            sort: [{ field: "field" }],
            filter: []
        }
    });

    const checkRows = (checked, rowData) => {
        const newChecked = new Set(values);
        if (checked) {
            if (rowData.type_action === 'MENU' || rowData.type_action === 'SUMENU') {
                data.filter(p => p.work_flow_related === rowData.work_flow)
                    .forEach(p => newChecked.add(p.id));
            }
            else {
                data.filter(p => p.work_flow === rowData.work_flow_related)
                    .forEach(p => newChecked.add(p.id));
            }
            newChecked.add(rowData.id);
        }
        else {
            if (rowData.type_action === 'MENU' || rowData.type_action === 'SUMENU') {
                data.filter(p => p.work_flow_related === rowData.work_flow)
                    .forEach(p => newChecked.delete(p.id));
            }
            newChecked.delete(rowData.id);
        }
        handleDirectInputChange("access", [...newChecked]);
    }

    const cellWithEditing = (props) => {
        const { dataItem } = props;
        return <Box>
            <Checkbox
                defaultChecked
                size="small"
                onChange={(e) => checkRows(e.target.checked, dataItem)}
                checked={values.includes(dataItem.id)}
            />
        </Box>;
    };

    const columns = [
        {
            title: "",
            width: "20px",
            cell: cellWithEditing
        },
        {
            field: "name",
            title: "Nombre",
            width: "400px",
            filter: TreeListTextFilter,
            filterable: true,
            expandable: true
        },
        { field: "type_action", title: "Tipo", width: "200px" },
        { field: "work_flow", title: "Menu", width: "150px" },
        { field: "work_flow_related", title: "Menu_relaccionado", width: "150px" },
    ];

    const onExpandChange = (event) => {
        const updatedData = [...state.data];
        const toggleExpand = (items) => {
            return items.map(item => {
                if (item.id === event.dataItem.id) {
                    return { ...item, expanded: !event.value };
                } else if (item.children) {
                    return { ...item, children: toggleExpand(item.children) };
                }
                return item;
            });
        };

        setState({
            ...state,
            data: toggleExpand(updatedData)
        });
    };

    const Recurrent = useCallback((obj) => {
        const array = [];
        obj.forEach(element => {
            const children = [];
            if (element.work_flow) {
                const list = obj.filter(p => p.work_flow_related === element.work_flow);
                if (list.length > 0) {
                    list.forEach(item => {
                        children.push({
                            id: item.id,
                            name: item.name,
                            type_action: item.type_action,
                            work_flow: item.work_flow || '',
                            work_flow_related: item.work_flow_related || '',
                        })
                    })
                }
                obj.filter(p => p.work_flow_related !== element.work_flow)
            }

            if (element.type_action === 'MENU' || element.type_action === 'SUMENU') {
                if (children.length > 0)
                    array.push({
                        id: element.id,
                        name: element.name,
                        type_action: element.type_action,
                        work_flow: element.work_flow || '',
                        work_flow_related: element.work_flow_related || '',
                        children: children
                    });
                else
                    array.push({
                        id: element.id,
                        name: element.name,
                        type_action: element.type_action,
                        work_flow: element.work_flow || '',
                        work_flow_related: element.work_flow_related || '',
                    });
            }
        });
        return array;
    }, []);

    useEffect(() => {
        const array = Recurrent(data);
        setState({
            ...state,
            data: array
        });
    }, [data]);

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                {t("group.associatedActions")}
            </Typography>
            <Grid size={{xs:12, sm:8}}>
                <TreeList
                    style={{ maxHeight: "550px", overflow: "auto", width: '100%' }}
                    expandField={expandField}
                    subItemsField={subItemsField}
                    onExpandChange={onExpandChange}
                    sortable={{ mode: "multiple" }}
                    filterable
                    {...state.dataState}
                    // PERMITEN FILTRAR
                    onDataStateChange={(e) => setState({ ...state, dataState: e.dataState })}
                    data={filterBy(orderBy(state.data, state.dataState.sort, subItemsField), state.dataState.filter, subItemsField)}
                    columns={columns}
                />
            </Grid>
        </Box>
    )
}